import NavActions from '/b2b/common/state/nav/Nav.actions';

export const selectCustomer = customer => dispatch => {
    dispatch(NavActions.changeCustomer(customer));
    return Promise.resolve(customer);
};
